var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-animation" }, [
    _vm.staticImageSrc
      ? _c(
          "picture",
          {
            staticClass: "main-animation__background",
            attrs: { role: "none", "aria-hidden": "true" }
          },
          [
            _c("img", {
              attrs: {
                src: _vm.staticImageSrc,
                srcset: _vm.staticImage2xSrcSet
              }
            })
          ]
        )
      : _vm._e(),
    _vm.movingImageSrc
      ? _c(
          "picture",
          {
            staticClass: "main-animation__foreground",
            attrs: { role: "none", "aria-hidden": "true" }
          },
          [
            _c("img", {
              attrs: {
                src: _vm.movingImageSrc,
                srcset: _vm.movingImage2xSrcSet
              }
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df7cda9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df7cda9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/MainPageAnimation.vue
// module id = EDtt
// module chunks = 0 2